import request from "../Config/axios";
// -----------------------------------------------------------
export const GetAll_SubPeriod_Api = async (periodId) => {
    const { data } = await request.get(
        `/SubPeriod/GetAll/?periodId=${periodId}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Paging_SubPeriod_Api = async (params) => {
    const { data } = await request.post(
        `/SubPeriod/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_SubPeriod_Api = async (params) => {
    const { data } = await request.post(
        `/SubPeriod/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Active_SubPeriod_Api = async (periodId) => {
    const { data } = await request.get(
        `/SubPeriod/GetAll_Active/?periodId=${periodId}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_SubPeriod_Api = async (id) => {
    const { data } = await request.get(
        `/SubPeriod/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_SubPeriod_Api = async (params) => {
    const { data } = await request.post(
        `/SubPeriod/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_SubPeriod_Api = async (id) => {
    const { data } = await request.delete(
        `/SubPeriod/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
